import { applyMiddleware, combineReducers, compose, createStore } from "redux"
import thunk from "redux-thunk"
//import { reducer as formReducer } from "redux-form"
import getValue from "object-getvalue"
import * as rootReducer from "../reducers/index"
import { getDY_SR } from "stackerConfig"

const combinerRootReducer = combineReducers({
  ...rootReducer,
})

function configureStore() {
  //const middleware = [historyMiddleware, thunk];
  const middleware = [thunk]

  let composeEnhancers
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { composeWithDevTools } = require("@redux-devtools/extension")
    composeEnhancers = composeWithDevTools({
      // Specify here name, actionsBlacklist, actionsCreators and other options if needed
    })
  }

  const finalEnhancer = composeEnhancers || compose
  const store = createStore(
    combinerRootReducer,
    finalEnhancer(applyMiddleware(...middleware))
  )

  getDY_SR().functions = {
    dispatch: store.dispatch,
  }

  return store
}

// Singleton Store instance
let mainStore

function getStoreInstance() {
  if (typeof mainStore === "undefined") {
    mainStore = configureStore()
  }
  return mainStore
}

export { getStoreInstance }
